angular.module('impactx.budget').service('BudgetImportService', BudgetImportService);

BudgetImportService.$inject = ['$mdDialog'];

function BudgetImportService($mdDialog) {

    this.showUploadDialog = function(event, trns, entryPoint) {
        $mdDialog.show({
            controller: "BudgetImportController",
            controllerAs: "budgetImportController",
            templateUrl: "modules/budget/templates/budget-import.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                trns: trns,
                entryPoint: entryPoint
            }
        });
    };
}
